module.exports = __webpack_public_path__ + "img/basketball_m.166c9e3f.svg";